/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_File_TypesInputs */

const en_dialog_premium_file_types = /** @type {(inputs: Dialog_Premium_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload more file types with Listening Premium`)
};

const es_dialog_premium_file_types = /** @type {(inputs: Dialog_Premium_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube más tipos de archivos con Listening Premium`)
};

/**
* | output |
* | --- |
* | "Upload more file types with Listening Premium" |
*
* @param {Dialog_Premium_File_TypesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_file_types = /** @type {((inputs?: Dialog_Premium_File_TypesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_File_TypesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_file_types(inputs)
	return en_dialog_premium_file_types(inputs)
});